const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const VirtualMachine = require('../../virtual-machine');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 无线LED灯
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x01FF,
//     LIGHT_MODE_UUID: 0x0200,
//     ledSwitch: 0x0201,
//     ledBrightness: 0x0202,
//     FLASH_FREQUENCY_UUID: 0x0203,
//     ledFlashOnce: 0x0204,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YCAIS extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYCAISDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'yc-ais';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        // Create a new YM-LED peripheral instance
        this._peripheral = new YCAIS(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'ycAIS',
            name: formatMessage({
                id: 'YCAIS.categoryName',
                default: 'YC AIS',
                description: 'Label for the YC AIS extension category'
            }),
            color1: "#FF7566",
            color2: "#6DB14D",
            color3: "#64A23C",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ble.connect',
                        default: 'connect to YC-AIS-[DEVICE_NAME]',
                        description: 'Connect to YC AIS'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ble.disconnect',
                        default: 'disconnect from YC AIS',
                        description: 'Disconnect from YC AIS'
                    })
                },
                // {
                //     opcode: 'setLightMode',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'YMLED.setLightMode',
                //         default: 'set light mode [MODE]',
                //         description: 'Set the light mode'
                //     }),
                //     arguments: {
                //         MODE: {
                //             type: ArgumentType.NUMBER,
                //             menu: 'lightModes'
                //         }
                //     }
                // },
               
                // {
                //     opcode: 'programmeStart',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'YCAIS.programme.start',
                //         default: 'start programming mode',
                //         description: 'Enter programming mode'
                //     })
                // },
                // {
                //     opcode: 'sendFileName',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'YCAIS.programme.sendFileName',
                //         default: 'send file name [FILENAME]',
                //         description: 'Send file name in programming mode'
                //     }),
                //     arguments: {
                //         FILENAME: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'main.c'
                //         }
                //     }
                // },
                // //TODO: 积木进行分组最好能分组命名
                
                // {
                //     opcode: 'endFileSend',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'YCAIS.programme.endFileSend',
                //         default: 'end file send',
                //         description: 'End file sending and save file'
                //     })
                // },
                // {
                //     opcode: 'endProgramming',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'YCAIS.programme.endProgramming',
                //         default: 'end programming mode',
                //         description: 'End programming mode'
                //     })
                // },
                // {
                //     opcode: 'abortProgramming',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'YCAIS.programme.abortProgramming',
                //         default: 'abort programming mode',
                //         description: 'Abort programming mode'
                //     })
                // },
                {
                    opcode: 'createScreen',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YCAIS.ui.createScreen',
                        default: 'create screen',
                        description: 'Create screen object'
                    })
                },

                {
                    opcode: 'showScreen',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.showScreen',
                        default: 'show screen [SCREEN]',
                        description: 'Show the specified screen'
                    }),
                    arguments: {
                        SCREEN: {
                            type: ArgumentType.STRING,
                            defaultValue: 'screen1'
                        }
                    }
                },
                {
                    opcode: 'delay',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.util.delay',
                        default: 'delay [TIME] ms',
                        description: 'Delay for specified milliseconds'
                    }),
                    arguments: {
                        TIME: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        }
                    }
                },
                {
                    opcode: 'setScreenBgColor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.setScreenBgColor',
                        default: 'set screen [SCREEN] background color to [COLOR]',
                        description: 'Set screen background color'
                    }),
                    arguments: {
                        SCREEN: {
                            type: ArgumentType.STRING,
                            defaultValue: 'screen1'
                        },
                        COLOR: {
                            type: ArgumentType.STRING,
                            menu: 'colorOptions'
                        }
                    }
                },
                {
                    opcode: 'createLabel',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YCAIS.ui.createLabel',
                        default: 'create label on screen [SCREEN] with text [TEXT] at x:[X] y:[Y] width:[WIDTH] height:[HEIGHT]',
                        description: 'Create label object'
                    }),
                    arguments: {
                        SCREEN: {
                            type: ArgumentType.STRING,
                            defaultValue: 'screen1'
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'yiOS'
                        },
                        X: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        },
                        Y: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        },
                        WIDTH: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        },
                        HEIGHT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50
                        }
                    }
                },
                {
                    opcode: 'setLabelColor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.setLabelColor',
                        default: 'set label [LABEL] color to [COLOR]',
                        description: 'Set label color'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'label1'
                        },
                        COLOR: {
                            type: ArgumentType.STRING,
                            menu: 'colorOptions'
                        }
                    }
                },
                {
                    opcode: 'setLabelFont',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.setLabelFont',
                        default: 'set label [LABEL] font to [FONT]',
                        description: 'Set label font'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'label1'
                        },
                        FONT: {
                            type: ArgumentType.STRING,
                            menu: 'fontOptions'
                        }
                    }
                },
                {
                    opcode: 'setLabelText',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.setLabelText',
                        default: 'set label [LABEL] text to [TEXT]',
                        description: 'Set label text'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'label1'
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Hello'
                        }
                    }
                },
                {
                    opcode: 'setLabelAlign',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.setLabelAlign',
                        default: 'set label [LABEL] alignment to [ALIGN]',
                        description: 'Set label alignment'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'label1'
                        },
                        ALIGN: {
                            type: ArgumentType.STRING,
                            menu: 'alignOptions'
                        }
                    }
                },
                {
                    opcode: 'setLabelPosition',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YCAIS.ui.setLabelPosition',
                        default: 'set label [LABEL] position to x:[X] y:[Y]',
                        description: 'Set label position'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            defaultValue: 'label1'
                        },
                        X: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        },
                        Y: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        }
                    }
                },{
                    opcode: 'float2str',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YCAIS.util.float2str',
                        default: 'convert float [FLOAT_VALUE] to string',
                        description: 'Convert float value to string representation for C code generation'
                    }),
                    arguments: {
                        FLOAT_VALUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.0
                        }
                    }
                },
                {
                    opcode: 'int2str',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YCAIS.util.int2str',
                        default: 'convert int [INT_VALUE] to string',
                        description: 'Convert integer value to string representation for C code generation'
                    }),
                    arguments: {
                        INT_VALUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                }
            ],
            menus: {
                colorOptions: {
                    items: [
                        { text: 'white', value: 'COLOR_WHITE' },
                        { text: 'dark green', value: 'COLOR_DARK_GREEN' },
                        { text: 'dark gray', value: 'COLOR_DARK_GRAY' },
                        { text: 'wechat green', value: 'COLOR_WECHAT_GREEN' },
                        { text: 'medium gray', value: 'COLOR_MEDIUM_GRAY' },
                        { text: 'light gray', value: 'COLOR_LIGHT_GRAY' },
                        { text: 'red', value: 'COLOR_RED' },
                        { text: 'yellow', value: 'COLOR_YELLOW' },
                        { text: 'green', value: 'COLOR_GREEN' },
                        { text: 'blue', value: 'COLOR_BLUE' },
                        { text: 'black', value: 'COLOR_BLACK' }
                    ]
                },
                fontOptions: {
                    items: [
                        { text: 'small (14px)', value: 'FONT_SMALL' },
                        { text: 'medium (20px)', value: 'FONT_MEDIUM' },
                        { text: 'large (20px)', value: 'FONT_LARGE' },
                        { text: 'icon small (14px)', value: 'FONT_ICON_SMALL' },
                        { text: 'icon medium (20px)', value: 'FONT_ICON_MEDIUM' },
                        { text: 'icon large (30px)', value: 'FONT_ICON_LARGE' }
                    ]
                },
                alignOptions: {
                    items: [
                        { text: 'default (top left)', value: 'ALIGN_DEFAULT' },
                        { text: 'top left', value: 'ALIGN_TOP_LEFT' },
                        { text: 'top center', value: 'ALIGN_TOP_MID' },
                        { text: 'top right', value: 'ALIGN_TOP_RIGHT' },
                        { text: 'bottom left', value: 'ALIGN_BOTTOM_LEFT' },
                        { text: 'bottom center', value: 'ALIGN_BOTTOM_MID' },
                        { text: 'bottom right', value: 'ALIGN_BOTTOM_RIGHT' },
                        { text: 'center left', value: 'ALIGN_LEFT_MID' },
                        { text: 'center right', value: 'ALIGN_RIGHT_MID' },
                        { text: 'center', value: 'ALIGN_CENTER' }
                    ]
                }
            }
        }];
    }

    async connect(args) {
        const deviceName = 'YC-AIS-' + (args.DEVICE_NAME?.trim() || "");
        console.log(`Connecting to YC AIS device: ${deviceName}`);
        // Check if the device is already connected
        if (this.bleUtils.device && this.bleUtils.isConnected(this.bleUtils.device)) {
            console.log('Device is already connected');
            return;
        }
        // Attempt to connect to the device
        // Use the bleUtils to connect to the device
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);
        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async disConnect() {
        console.log('Disconnecting from YC AIS device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }


/**
 * 开始编程模式
 */
async programmeStart() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.programme // 需要在BLE_CONFIG中定义对应的UUID
        );
        const commandData = new TextEncoder().encode('prog start\r');
        await this.bleUtils.writeCharacteristic(characteristic, cmd);
    } catch (error) {
        console.error('Failed to start programming mode:', error);
    }
}
// 返回一个屏幕标识符（字符串）
async createScreen(args) {
    // 可以生成唯一ID，或固定值
    return '';
}

// 返回一个标签标识符（字符串）
/**
 * 对于要可设置到变量的积木
 * 在摆放积木时，如果积木中有变量，并且触发了连接动作，出现了弹窗，需要补充对应的方法；
 * 不然默认返回undefined，会导致变量赋值失败。从而导出后的sb3文件再次导入会失败
 * @param {*} args 
 * @returns 
 */
async createLabel(args) {
    // 简单返回一个ID，实际可存入内部状态供后续操作使用
    return '';
}
/**
 * 将浮点数转换为字符串（用于C代码生成）
 * @param {object} args - 参数对象
 * @param {number} args.FLOAT_VALUE - 要转换的浮点数值
 * @returns {string} 生成的C代码字符串
 */
float2str(args) {
    
    
    // 返回C代码模板，供其他部分使用
    return '';
}

/**
 * 将整数转换为字符串（用于C代码生成）
 * @param {object} args - 参数对象
 * @param {number} args.INT_VALUE - 要转换的整数值
 * @returns {string} 生成的C代码字符串
 */
int2str(args) {
  
    
    // 返回C代码模板，供其他部分使用
    return '';
}
/**
 * 发送文件名
 */
async sendFileName(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        // 先发送文件名开始标志
        const controlChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.programme
        );
        const startCmd = new Uint8Array([0x01]);
        await this.bleUtils.writeCharacteristic(controlChar, startCmd);
        
        // 再发送文件名内容
        const filenameChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.programme // 需要在BLE_CONFIG中定义对应的UUID
        );
        const filenameData = new TextEncoder().encode(args.FILENAME);
        await this.bleUtils.writeCharacteristic(filenameChar, filenameData);
    } catch (error) {
        console.error('Failed to send file name:', error);
    }
}

/**
 * 发送文件内容
 */

/**
 * 结束文件发送并保存
 */
async endFileSend() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.programme
        );
        const cmd = new Uint8Array([0x03]); // 结束文件发送命令
        await this.bleUtils.writeCharacteristic(characteristic, cmd);
    } catch (error) {
        console.error('Failed to end file send:', error);
    }
}

/**
 * 结束编程模式
 */
async endProgramming() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.programme
        );
        const cmd = new Uint8Array([0x04]); // 结束编程模式命令
        await this.bleUtils.writeCharacteristic(characteristic, cmd);
    } catch (error) {
        console.error('Failed to end programming mode:', error);
    }
}

/**
 * 中止编程模式
 */
async abortProgramming() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.programmeControl
        );
        const cmd = new Uint8Array([0x18]); // 中止编程模式命令
        await this.bleUtils.writeCharacteristic(characteristic, cmd);
    } catch (error) {
        console.error('Failed to abort programming mode:', error);
    }
}


}

module.exports = ScratchYCAISDevice;